/**
 * wsclear-cart.js — カートを空にする (2026-08-13 Winds Score)
 *
 * 「カートの中身をまとめて消したい」というお問い合わせが多いため追加した。
 * 1点ずつ削除する導線しかなく、数が多いと手間だったのが理由。
 *
 * - ボタンは Liquid 側で出力する ([data-wsclear-wrap] / [data-wsclear])。
 *   対象フォーム: #CartPageForm (カートページ) / #CartDrawerForm (カートドロワー)
 * - 押すと確認ダイアログ → /cart/clear.js → 画面を再読み込み。
 *   カートの再描画はテーマの実装に踏み込まず、再読み込みで確実に合わせる。
 * - 中身は Ajax で描き替わるので、商品の有無は MutationObserver で追従する
 *   (wsqty-confirm.js と同じ作り)。数量欄 input[name="updates[]"] の数で判定する。
 * - JS が動かない環境ではボタンが出ないだけで、カートは普通に使える。
 */
(function () {
  'use strict';

  if (window.__wsClearLoaded) return; // main-cart / cart-drawer 両方から読まれるため二重実行を防ぐ
  window.__wsClearLoaded = true;

  var CONFIRM_TEXT = 'カートに入っている商品をすべて削除します。よろしいですか？';
  var FAIL_TEXT = 'カートを空にできませんでした。お手数ですが、画面を再読み込みしてお試しください。';

  function closest(el, selector) {
    if (el && el.closest) return el.closest(selector);
    return null;
  }

  function lineCount(form) {
    return form ? form.querySelectorAll('input[name="updates[]"]').length : 0;
  }

  /* 商品が入っているときだけ出す (空のカートに「空にする」は出さない) */
  function syncWrap(wrap) {
    wrap.hidden = lineCount(closest(wrap, 'form')) === 0;
  }

  function syncAll() {
    var wraps = document.querySelectorAll('[data-wsclear-wrap]');
    for (var i = 0; i < wraps.length; i++) syncWrap(wraps[i]);
  }

  function clearCart(btn) {
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '削除しています…';

    fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/clear failed: ' + res.status);
        /* カートページは空のときの画面が Liquid 側なので読み込み直す。
           ドロワーで押したときは開いたまま「カートは空です」に切り替える */
        if (document.getElementById('CartPageForm')) {
          window.location.reload();
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:build'));
        setTimeout(syncAll, 300);
        btn.disabled = false;
        btn.textContent = label;
      })
      .catch(function (err) {
        if (window.console) console.error('カートを空にできませんでした', err);
        btn.disabled = false;
        btn.textContent = label;
        window.alert(FAIL_TEXT);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = closest(e.target, '[data-wsclear]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    if (!window.confirm(CONFIRM_TEXT)) return;
    clearCart(btn);
  });

  /* 1点ずつの「削除」は素のリンク (/cart/change?id=…&quantity=0) なので、
     押すとページごと移動してしまう。ドロワーなら開いていたドロワーが閉じ、
     カートページでも画面が丸ごと再読み込みされる。
     そこで Ajax (/cart/change.js) で消し、テーマに再描画だけさせて画面はそのまま保つ。

     2026-08-13 の実装は「数量欄を 0 にして change を投げ、駄目なら 1.2 秒後に reload」
     だったが、テーマは input の change ではなく自前の `cart:quantity` イベントで動くため
     ほぼ毎回この保険が走り、結局 reload されてドロワーが閉じていた (2026-08-17 実測)。
     テーマの再描画は `cart:build` を投げれば起こせるので、reload は完全にやめる。 */
  function removeLine(link) {
    var row = closest(link, '.cart__item') || closest(link, '.cart__qty-row');
    var input = row && row.querySelector('input[name="updates[]"]');
    var key = input && input.getAttribute('data-id');
    if (!key) return false; /* 行が特定できないときは元のリンク動作に任せる */

    if (row) row.style.opacity = '0.5';
    link.style.pointerEvents = 'none';

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/change failed: ' + res.status);
        return res.json();
      })
      .then(function (cart) {
        /* カートページの「カートは空です」表示は Liquid 側 (cart.item_count > 0) で
           作られているので、JS では切り替えられない。最後の1点を消したときだけ読み込み直す。
           ドロワーは空のとき用の表示を自前で持っているのでそのままでよい */
        if (cart && cart.item_count === 0 && document.getElementById('CartPageForm')) {
          window.location.reload();
          return;
        }
        /* テーマ (theme.js の CartForm) はこのイベントでカートを組み直す。
           ドロワー・カートページのどちらも、開いたまま中身だけ入れ替わる */
        document.dispatchEvent(new CustomEvent('cart:build'));
        setTimeout(syncAll, 300);
      })
      .catch(function (err) {
        if (window.console) console.error('商品を削除できませんでした', err);
        /* 通信に失敗したときだけ、元のリンクどおりの動きに戻す */
        if (row) row.style.opacity = '';
        link.style.pointerEvents = '';
        window.location.href = link.getAttribute('href');
      });
    return true;
  }

  document.addEventListener('click', function (e) {
    var link = closest(e.target, '.cart__remove a');
    if (!link) return;
    var form = closest(link, 'form');
    if (!form || (form.id !== 'CartPageForm' && form.id !== 'CartDrawerForm')) return;
    if (removeLine(link)) e.preventDefault();
  }, true);

  function start() {
    var forms = document.querySelectorAll('#CartPageForm, #CartDrawerForm');
    for (var i = 0; i < forms.length; i++) {
      if (!window.MutationObserver) break;
      /* タイマーはフォームごとに持つ (var を for の中で宣言すると
         ループ全体で1つを共有してしまい、片方の監視が相手を打ち消す) */
      observeForm(forms[i]);
    }
    syncAll();
  }

  function observeForm(form) {
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(syncAll, 60);
    }).observe(form, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
